<!--components\Paneles\PanelTipo5.vue-->
<!--parrafo+boton-->
<template>
  <div class="justify-center max-w-[76rem] items-center flex flex-col w-full h-auto gap-[1rem] bg-ROJO_LEON rounded-lg py-[2rem] px-[1rem] md:px-[0rem]">
    <p :class="['text-lg text-white', clasetexto]">{{ texto }}</p>
    <div class="flex flex-col">
      <BotonAnimadoTipo1
        button-classes="flex items-center bg-slate-700 font-bold text-white text-sm md:text-base py-1 px-4 rounded hover:bg-VERDE_TOP_CALIDAD"
        :svg-tipo="2"
        @click="abrirPop"
        :texto="textoboton"
      />
    </div>
  </div>
</template>

<script setup>
import BotonAnimadoTipo1 from "~/components/Botones/BotonAnimadoTipo1.vue";

defineProps({
  texto: {
    type: String,
    default: 'Locales León'
  },
  textoboton: {
    type: String,
    default: 'Ver más'
  },
  clasetexto: {
    type: String,
    default: ''
  },
  
});

const emit = defineEmits(['ver-mas']);

const abrirPop = () => {
  emit('ver-mas');
};
</script>